import dynamic from "next/dynamic";
import LongFooterConfig from "./long-footer-config";
import LongFooterAdvancedConfig from "./long-footer-advanced-config";
const LongFooterComponent = dynamic(()=>import("./long-footer-component"));
export default {
    LongFooterComponent,
    LongFooterConfig,
    LongFooterAdvancedConfig
};
